import React from 'react';
import { createPortal } from 'react-dom';

// Portals keep dialogs outside transformed page and navigation stacking contexts.
const ModalLayer = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>((props, ref) =>
  createPortal(<div role="dialog" aria-modal="true" {...props} ref={ref} className={`modal-layer ${props.className || ''}`} />, document.body)
);
ModalLayer.displayName = 'ModalLayer';
export default ModalLayer;
